import React, {useEffect, useRef, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../redux";
import {
    getTopFixtures,
} from "../redux/slices/fixtures";
import moment from "moment";

import {formatGameMinute} from "../utils";
import {useNavigate} from "react-router-dom";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import ScrollComponent from "../components/scroll/ScrollComponent";
import './PreMatch.scss'

export default function PreMatch() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [currentTime, setCurrentTime] = useState(moment())

    useEffect(() => {
        dispatch(getTopFixtures());

        const interval = setInterval(() => {
            setCurrentTime(moment());
        }, 1000);

        return () => clearInterval(interval);
    }, [dispatch]);

    const { topFixtures} = useAppSelector(state => state.fixtures)

    const onClickGame = async (event: any) => {
        return navigate(`/football/match/${event.id}`);
    }

    return (
        <div className="pre-match-wrapper">
            <div>
                <h1>Today's Critical Matches: Top 6 Analyzed for High Vulnerability and Performance</h1>
            </div>
            <ScrollComponent watch={topFixtures}>
                <div className="top-fixtures-wrapper">
                    {
                        topFixtures.map((fixture: any) => {
                            return <div className="fixture-wrapper card-shadow" onClick={() => onClickGame(fixture)}>
                                <div className="fixture-header">
                                    <div className="competition-name">
                                        <div className="logo" style={{
                                            backgroundImage: `url(${
                                                fixture.tournament?.uniqueTournament?.image
                                            })`
                                        }}/>
                                        {fixture.tournament.name}
                                        {
                                            fixture.roundInfo &&
                                            ", Round " + fixture.roundInfo.round
                                        }
                                    </div>
                                    <div className='board'>
                                        <div className="home">
                                            <div className="logo" style={{
                                                backgroundImage: `url(${
                                                    fixture.homeTeam?.image
                                                })`
                                            }}></div>
                                            <div className="name">{fixture.homeTeam.shortName}</div>
                                        </div>
                                        <div className="time">
                                            {
                                                fixture.status.type === 'notstarted' &&
                                                <div>
                                                    <div className="time">
                                                        {moment.unix(fixture.startTimestamp).fromNow()}
                                                    </div>
                                                    <div className="date">
                                                        {moment.unix(fixture.startTimestamp).format('Do MMM YY, HH:mm')}
                                                    </div>
                                                </div>
                                            }

                                            {
                                                fixture.status.type === 'finished' &&
                                                <div>
                                                    <div className="score">
                                                        {fixture.homeScore.display} - {fixture.awayScore.display}
                                                    </div>
                                                    <div className="date">
                                                        {moment.unix(fixture.startTimestamp).format('Do MMM YY, HH:mm')}
                                                    </div>
                                                </div>
                                            }
                                            {
                                                fixture.status.type === 'inprogress' &&
                                                <div>
                                                    {
                                                        fixture.homeScore.display !== fixture.homeScore.current ?
                                                            <span className='score'>{fixture.homeScore.display}
                                                                <span
                                                                    className='score'>{fixture.homeScore.current}</span>
                                                        </span> :
                                                            fixture.homeScore.hasOwnProperty('display') &&
                                                            <span className='score'>{fixture.homeScore.display}</span>
                                                    }
                                                    {fixture.status.type !== 'notstarted' && <span>-</span>}
                                                    {
                                                        fixture.awayScore.display !== fixture.awayScore.current ?
                                                            <span>
                                                            <span className='score'>
                                                                {fixture.awayScore.current}
                                                            </span>
                                                                {fixture.awayScore.display}
                                                        </span> :
                                                            fixture.awayScore.hasOwnProperty('display') &&
                                                            <span className='score'>{fixture.awayScore.display}</span>
                                                    }
                                                    {fixture.status.type === 'inprogress' && (
                                                        <div className="minute live-game">
                                                            {fixture.status.description === 'Halftime' ? 'HT' : <>
                                                                {formatGameMinute(fixture)}
                                                                <span style={{animation: 'blink 1s infinite'}}>'</span>
                                                            </>}
                                                        </div>
                                                    )}
                                                </div>
                                            }

                                        </div>
                                        <div className="away">
                                            <div className="logo" style={{
                                                backgroundImage: `url(${
                                                    fixture.awayTeam?.image
                                                })`
                                            }}></div>
                                            <div className="name">
                                                {fixture.awayTeam.shortName}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    fixture.odds?.length &&
                                    <div className="fixture-body">
                                        <div className="fixture-body-left"
                                             style={fixture.homeScore.display > fixture.awayScore.display && fixture.status.type === 'finished' ? {background: 'var(--primary-color)'} : {}}>
                                            <div className="option">1</div>
                                            <div
                                                className="value">{fixture.odds?.find((o) => o.choiceName === '1').valueDecimal}</div>
                                        </div>
                                        <div className="fixture-body-middle"
                                             style={fixture.homeScore.display === fixture.awayScore.display && fixture.status.type === 'finished' ? {background: 'var(--primary-color)'} : {}}>
                                            <div className="option">X</div>
                                            <div
                                                className="value">{fixture.odds?.find((o) => o.choiceName === 'X').valueDecimal}</div>
                                        </div>
                                        <div className="fixture-body-right"
                                             style={fixture.homeScore.display < fixture.awayScore.display && fixture.status.type === 'finished' ? {background: 'var(--primary-color)'} : {}}>
                                            <div className="option">2</div>
                                            <div
                                                className="value">{fixture.odds?.find((o) => o.choiceName === '2').valueDecimal}</div>
                                        </div>
                                    </div>
                                }

                                <hr/>

                                <div className="fixture-footer">
                                    <div className="stats">
                                        <div className="home">
                                            {
                                                fixture.picks.slice(0, 3).map((stat: any) => {
                                                    const totalGoals = stat.home + stat.away;
                                                    const homePercentage = (stat.home / totalGoals) * 100;
                                                    const awayPercentage = (stat.away / totalGoals) * 100;

                                                    return (
                                                        <div className="option">
                                                            <div className="type">{stat.name}</div>
                                                            <div className="value-wrapper">
                                                                <div className="home"
                                                                     style={{width: `${homePercentage}%`}}>{stat.home}</div>
                                                                <div className="away"
                                                                     style={{width: `${awayPercentage}%`}}>{stat.away}</div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                            <div className="show-more">
                                                Show more <ExpandMoreIcon/>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        })
                    }
                </div>
            </ScrollComponent>
        </div>
    );
}
